/* eslint-disable camelcase */

import drivers from './taxi/drivers'
import cars from './taxi/cars'
import contracts from './taxi/contracts'
import scans from './taxi/scans'
import serve from './taxi/serve'
import mapcars from './taxi/mapcars'
import companies from './taxi/companies'
import templates from './taxi/templates'
import users from './taxi/users'
import ioParameters from './taxi/ioParameters'
import trips from './taxi/trips'
import trackDevices from './taxi/track-devices'
import serviceWorks from './taxi/service-works'
import servecars from './taxi/servecars'

const state = {
  modulesLoaded: []
}

const actions = {
}

const getters = {
}

const mutations = {
}

export default {
  namespaced: true,
  modules: {
    drivers,
    cars,
    contracts,
    scans,
    serve,
    users,
    mapcars,
    companies,
    templates,
    ioParameters,
    trips,
    trackDevices,
    serviceWorks,
    servecars
  },
  state,
  actions,
  mutations,
  getters
}
